<template>
    <b-badge class="badge-range md f-400" :variant="status.variant" :title="tr(status.title)">
        <i class="fas mr-1" :class="status.glyph"/>
        <slot></slot>
    </b-badge>
</template>

<script>
export default {
    name: `badge-range`,
    props: {
        value: {type: Number},
        minRange: {type: Number},
        maxRange: {type: Number},
        errorDelta: {type: Number, default: 0.75}
    },
    computed: {
        distance() {
            if (this.value < this.minRange) {
                return (this.minRange - this.value) / this.minRange;
            } else if (this.value > this.maxRange) {
                return (this.value - this.maxRange) / this.maxRange;
            } else {
                return 0;
            }
        },
        status() {
            if (this.distance === 0) {
                return {
                    variant: `light-success`,
                    glyph: `fa-circle-check`,
                    title: `Within Recommended Range|Correspond aux valeurs recommandées`
                };
            } else {
                const variant = Math.abs(this.distance) > this.errorDelta ? `light-danger` : `light-warning`;
                let glyph = `fa-chevron-down`;
                let title = `Above Recommended Range|Au dessus des valeurs recommendées`;
                if (this.value < this.minRange) {
                    glyph = `fa-chevron-up`;
                    title = `Below Recommended Range|En dessous des valeurs recommendées`;
                }

                return {
                    variant,
                    glyph,
                    title
                };
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
